import React from 'react';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getReportName, useReportStateSnapshot } from '../../store/store';

export default function HEADER() {
  var reportState = useReportStateSnapshot();
  var reportName = reportState.ReportName;

  console.log("HDR reportName: ", reportName);
  return (
    <header className="w-[1224px] fixed top-0">
      <div className="flex flex-row h-[72px] bg-[#424274]">
        <Link to="http://percentage.com" className='w-3/12 pl-4'>
          <img src={require("../../images/percentagelogo.jpg")}
          alt='' 
          width={216}
          height={72}
          />
        </Link>
        <div className='w-6/12 flex justify-center text-white text-2xl font-bold items-center'>{reportName}</div>
        <div className='w-3/12 pr-10 flex justify-end items-center text-white '>
          <Link to="/">Home</Link>
        </div>
      </div>
    </header>
  );
}
